<template>
  <div class="block-form">
    <q-input
      outlined
      :model-value="block.title"
      label="Título (opcional)"
      @update:model-value="emit('update', { ...block, title: String($event ?? '') })"
    />

    <div class="form-label">Puntos</div>
    <div
      v-for="(point, idx) in block.points"
      :key="idx"
      class="item-row"
    >
      <q-input
        outlined
        dense
        :model-value="point"
        :label="`Punto ${idx + 1}`"
        style="flex: 1;"
        @update:model-value="updatePoint(idx, String($event ?? ''))"
      />
      <q-btn
        flat
        dense
        round
        icon="delete"
        color="negative"
        @click="removePoint(idx)"
      >
        <q-tooltip>Eliminar punto</q-tooltip>
      </q-btn>
    </div>

    <q-btn
      flat
      no-caps
      icon="add"
      label="Agregar punto"
      color="primary"
      size="sm"
      @click="addPoint"
    />
  </div>
</template>

<script setup lang="ts">
interface KeyPointsBlock {
  type: 'key_points';
  title?: string;
  points: string[];
}

const props = defineProps<{ block: KeyPointsBlock }>();
const emit = defineEmits<{ (e: 'update', block: KeyPointsBlock): void }>();

function updatePoint(idx: number, value: string) {
  const points = [...props.block.points];
  points[idx] = value;
  emit('update', { ...props.block, points });
}

function removePoint(idx: number) {
  const points = props.block.points.filter((_, i) => i !== idx);
  emit('update', { ...props.block, points });
}

function addPoint() {
  emit('update', { ...props.block, points: [...props.block.points, ''] });
}
</script>

<style scoped lang="scss">
.block-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
}
.form-label {
  font-size: 13px;
  color: var(--oa-text-muted);
}
.item-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>
